export const awardAmountTypeCollection = {
        range: 'range',
        values: 'values'
    }